import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { Serializable } from './serializable.model';
import { AttributeKey } from './tag.model';

export class TagAttribute implements Deserializable<any, TagAttribute>, Serializable<JsonObject> {
  constructor(public id?: string, public key?: AttributeKey) {}

  deserialize(input: any): TagAttribute {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.key = input.tagAttributeKey as AttributeKey;
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['id'] = this.id;
    json['tagAttributeKey'] = this.key;

    return json;
  }
}
